import { render, staticRenderFns } from "./jumpApp.vue?vue&type=template&id=1ea68cf8&scoped=true&"
import script from "./jumpApp.vue?vue&type=script&lang=js&"
export * from "./jumpApp.vue?vue&type=script&lang=js&"
import style0 from "./jumpApp.vue?vue&type=style&index=0&id=1ea68cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea68cf8",
  null
  
)

export default component.exports